import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CorporationSkillFramework,
  CorporationSkillFrameworkData,
  CorporationSkillFrameworkListParams,
  CorporationSkillFrameworkSelectionRequest,
  CorporationSkillFrameworkUpdateRequest,
} from '../../entities/corporation-skill-frameworks.model';
import { DashboardApiService } from '../db-api.service';

const CORP_SELECTIONS_URL = '/v1/corporation/skill_framework_selections';

@Injectable({
  providedIn: 'root',
})
export class CorporationSkillFrameworkSelectionsApiService extends DashboardApiService {
  getFrameworkSelection(frameworkId: number): Observable<CorporationSkillFramework> {
    const url = `${CORP_SELECTIONS_URL}/${frameworkId}`;
    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  listFrameworkSelections(
    params: CorporationSkillFrameworkListParams = {},
  ): Observable<CorporationSkillFrameworkData> {
    const queryString = this._buildQueryString(params);
    const url = queryString ? `${CORP_SELECTIONS_URL}?${queryString}` : CORP_SELECTIONS_URL;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  createFrameworkSelection(
    request: CorporationSkillFrameworkSelectionRequest,
  ): Observable<CorporationSkillFramework> {
    return this._post(CORP_SELECTIONS_URL, { skill_framework_selection: request }).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }

  updateFrameworkSelection(
    frameworkId: number,
    request: CorporationSkillFrameworkUpdateRequest,
  ): Observable<CorporationSkillFramework> {
    const url = `${CORP_SELECTIONS_URL}/${frameworkId}`;
    return this._patch(url, { skill_framework_selection: request }).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }

  deleteFrameworkSelection(frameworkId: number): Observable<void> {
    const url = `${CORP_SELECTIONS_URL}/${frameworkId}`;
    return this._delete(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  private _buildQueryString<T extends object>(params: T): string {
    const query = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (value != null) {
        query.set(key, String(value));
      }
    }

    return query.toString();
  }
}
